import {isEmpty, isNumber} from 'lodash';

const AREA_FORM = {
  'primaryCode': 'Código Primario',
  'description': 'Descripcion',
  'status': 'Estado',
};

const validateFieldsForm = (areasFields, errorFields) => {
  let error = {
    'field': '',
    'error': false,
  };
  const errorArr = Object.keys(errorFields);

  errorArr.forEach((errorName) => {
    const field = areasFields[errorName];
    const selectField =
      isNumber(field) && isNaN(field) === false ? `${field}` : field;
    if (isEmpty(selectField)) {
      error = {
        'field': errorFields[errorName],
        'error': true,
      };
    }
  });

  return error;
};

export const validateErrorsAreas = (areaForm) => {
  const validateForm = validateFieldsForm(areaForm, AREA_FORM);

  if (validateForm.error) {
    return {
      'error': true,
      'message': `El campo ${validateForm.field} es requerido`,
    };
  }

  return {
    'error': false,
    'message': null,
  };
};
